import { AttributeModel } from "../main/dynamic/model/attribute.model"

export class CreateInstanceModel {
    id: string
    policyId: string
    attributes: AttributeModel[]

    constructor() {
        this.attributes = []
    }
}